module.exports = __webpack_public_path__ + "static/img/robot.281c9e20.png";